// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_g5-9";
export var fulfillmentFormRail = "_g5-8";
export var headerTitleRow = "_g5-b";
export var orderDetailsWrapper = "_g5-6";
export var paymentInformationGrid = "_g5-g";
export var paymentSummaryColumn = "_g5-h";
export var shipmentContainer = "_g5-a";
export var shipmentDetailsMainPane = "_g5-7";
export var shipmentNavigationCard = "_g5-4";
export var shipmentNavigationRail = "_g5-2";
export var shipmentNavigationRailHeader = "_g5-3";
export var shipmentSummaryFact = "_g5-d";
export var shipmentSummaryGrid = "_g5-c";
export var shipmentSummaryMetadataRow = "_g5-e";
export var shipmentSummaryTags = "_g5-f";
export var shipmentWorkspace = "_g5-0";
export var shipmentWorkspaceContent = "_g5-5";
export var shipmentWorkspaceHeader = "_g5-1";